export default "__VITE_ASSET__BNCQ8abj__"